import { useEffect } from 'react';
import { useAuth } from '../../contexts/KeycloakContext';
import { useNavigate } from 'react-router-dom';

export default function AuthCallback() {
  const navigate = useNavigate();
  const { keycloak, authenticated } = useAuth();

  useEffect(() => {
    const handleOAuthRedirect = async () => {
      try {
        // Keycloak OAuth2/OIDC handles the callback automatically
        // Just verify the user is authenticated and redirect

        if (authenticated && keycloak) {
          // User is authenticated, save info from token
          const tokenParsed = keycloak.tokenParsed;

          if (tokenParsed) {
            localStorage.setItem('userId', tokenParsed.sub);
            localStorage.setItem('email', tokenParsed.email || '');
            localStorage.setItem(
              'username',
              tokenParsed.preferred_username || tokenParsed.email?.split('@')[0] || 'user'
            );

            // Check if admin based on realm roles
            const roles = tokenParsed.realm_access?.roles || [];
            localStorage.setItem('isAdmin', String(roles.includes('admin')));

            navigate('/');
          } else {
            console.error('No token parsed from Keycloak');
            navigate('/');
          }
        } else if (authenticated === false) {
          navigate('/login');
        }
      } catch (error) {
        console.error('Unexpected error in OAuth callback:', error);
        navigate('/login');
      }
    };

    // Profile is ensured by the backend /ensure endpoint called from App.js or similar
    if (keycloak && authenticated !== undefined) {
      handleOAuthRedirect();
    }
  }, [navigate, keycloak, authenticated]);

  return <p>Confirming your account...</p>;
}
